import { handleSelectLang } from 'src/utils';
import './rewriteHeaderLogLink';
import './assets/_sass/other.scss';

handleSelectLang();
